const SITE_NAME = 'AnimeBookmark';

const formatPageTitle = (title = SITE_NAME) => {
    const text = `${title || SITE_NAME}`.trim();
    // Normalize explicit branding only; a page or account name may contain the brand.
    const pageTitle = text
        .replace(/\s+[|\u2013\u2014-]\s*AnimeBookmark$/u, '')
        .replace(/^AnimeBookmark\s*[|\u2013\u2014-]\s*/u, '')
        .trim();

    return !pageTitle || pageTitle === SITE_NAME
        ? SITE_NAME
        : `${SITE_NAME} - ${pageTitle}`;
};

module.exports = { formatPageTitle };
